import React, { Component } from 'react';
import PerfectScrollbar from 'perfect-scrollbar';
import $ from "jquery";

class StepOne extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            treatments: this.props.data.treatments,
            stylist: this.props.data.stylist,
            ps: null,
            psModal: null,
            sex: this.props.data.sex,
            currentTreatment: null,
            modal: null,
        }
    }
    
    componentDidMount = () => {
        this.height();
        this.initScrollbar();
        $(window).off();
        $(window).on("resize", this.resize.bind(this));
    }

    componentDidUpdate = () => {
        this.height();
        if (this.state.ps) {
        this.state.ps.update();
        } else {
            this.initScrollbar();
        }
    }

    initScrollbar = () => {
        if (document.querySelector(".stepOne-body")) {
            const ps = new PerfectScrollbar('.stepOne-body', {
                wheelSpeed: 2,
                wheelPropagation: true,
                minScrollbarLength: 20
            });
            this.setState((prevState) => {
                prevState.ps = ps;
                return prevState;
            });
        }
    }

    resize = () => {
        this.height();
        this.state.ps.update();
    }

    height = () => {    
        let totalHeight = $(window).height();
        totalHeight = (totalHeight > 900) ? 900 : totalHeight;
        let heightHeader = $(".header").outerHeight();
        let heightSteps = $(".steps").outerHeight();
        let heightPagination = $(".pagination-btns").outerHeight();
        
        let occupied = 
          heightHeader //header
        + heightSteps //steps
        + heightPagination
        - 15; //padding outer container stepOne-body
        
        let available = totalHeight - occupied + "px";
        document.querySelector(".stepOne").style.height = available;
    }

    uniqueid = () => {
        return Math.random().toString(36).replace(/[^a-z]+/g, '');
    }

    selectSex = (sex) => {
        this.setState((prevState) => {
                prevState.prevSex = prevState.sex;
                prevState.sex = sex;
                prevState.treatments = [];
                return prevState;
        }, () => {
            this.props.setSex(this.state.sex);
        });
    }

    isSubTreatmentChecked = (subTreatment) => {
        let result = false;
        this.state.treatments.forEach((treatment) => {
            if (treatment["sub"] === subTreatment["id"]) {
                result = true;
            }
        });
        return result;
    }

    isSexSelected = (name) => {
        let result = false;
        if (this.state.sex) {
            result = (name === this.state.sex);
        }
        return result;
    }

    isTreatmentSelected = (id) => {
        let result = false;
        this.state.treatments.forEach((treatment) => {
            if (treatment["id"] === id) {
                result = true;
            }
        });
        return result;
    }

    isStylistSelected = (id) => {
        return this.state.stylist["id"] === id;
    }

    isPreferenceStylistDone = () => {
        return this.state.stylist["id"] !== 0;
    }

    onClickSubTreatment = (e, subTreatment) => {
        let id = e.currentTarget.id;
        let checked = $("#" + id).is(":checked");
        if (checked) {
            $('input[name="' + e.currentTarget.name + '"]').each((index, item) => {
                if (item.id !== id) {
                    $( "#" + item.id).prop( "checked", false );
                }
            });
            this.setTreatment(subTreatment);
        } else {
            $('input[name="' + e.currentTarget.name + '"]').each((index, item) => {
                $( "#" + item.id).prop( "checked", false );
            });
           this.removeTreatment();
        }
    }

    setTreatment = (subTreatment) => {
        let found = false;
        this.state.treatments.forEach((treatment, index) => {
            if (treatment["id"] === this.state.currentTreatment["id"]) {
                this.setState((prevState) => {
                    prevState.treatments[index]["sub"] = subTreatment["id"];
                    prevState.treatments[index]["subname"] = subTreatment["naam"];
                    return prevState;
                }, () => this.props.setTreatments(this.state.treatments));
                found = true;
            }
        }, () => this.props.setTreatments(this.state.treatments));
        if (!found) {
            this.setState((prevState) => {
                let newTreatment = {
                    "id": this.state.currentTreatment["id"],
                    "sub": subTreatment["id"],
                    "name": this.state.currentTreatment["naam"],
                    "subname": subTreatment["naam"]
                };
                prevState.treatments.push(newTreatment);
                return prevState;
            }, () => this.props.setTreatments(this.state.treatments));
        }
    }

    removeTreatment = () => {
        this.state.treatments.forEach((treatment, index) => {
            if (treatment["id"] === this.state.currentTreatment["id"]) {
                this.setState((prevState) => {
                    prevState.treatments.splice(index, 1);
                    return prevState;
                }, () => this.props.setTreatments(this.state.treatments));
            }
        });
    }

    getNameSelectedSubTreatment = (id) => {
        let result;
        this.state.treatments.forEach((treatment) => {
            if (treatment["id"] === id) {
                result = "(" + this.decode(treatment["subname"]) + ")";
            }
        });
        return result;
    }

    getNameSelectedStylist = () => {
        let result;
        if (this.state.stylist || this.state.stylist === 0) {
            result = "Stylist: " + this.state.stylist["naam"];
        } else {
            result = "Voorkeur stylist";
        }
        return result;
    }

    renderHeader = () => {
        let content;
        let sexes = [];
        if (this.props.getdata["optie_vraag_geslacht"]) {         
            this.props.getdata["geslacht"].forEach((sex, index) => {
                let cls = this.isSexSelected(sex["naam"]) ? "button mr-1 mt-1 is-danger" : "button mr-1 mt-1";
                sexes.push(
                    <button className={cls} id={"sex_" + sex["naam"]} key={index} onClick={(e) => this.selectSex(sex["naam"])}>
                        {sex["naam"]}
                    </button>
                );
            });
        }
        if (this.props.getdata["optie_vraag_geslacht"]) {
            let cls = this.isPreferenceStylistDone() ? "button mr-1 mt-1 is-danger" : "button mr-1 mt-1";
            content = (
                <div className="columns">
                    <div className="column">
                        {sexes}
                        <button className={cls} onClick={this.openModal("stylists")}>
                            {this.getNameSelectedStylist()}
                        </button>
                    </div>
                </div>
            );
        } else {
            let cls = this.isPreferenceStylistDone() ? "button mr-1 mt-1 is-danger" : "button mr-1 mt-1";
            content = (
                <div className="columns">
                    <div className="column">
                        <button className={cls} onClick={this.onClickStylist}>
                            Voorkeur Stylist
                        </button>
                    </div>
                </div>
            );
        }
        return content;
    }

    getTreatments = () => {
        let treatments;
        if (this.props.getdata["optie_vraag_geslacht"]) {
            this.props.getdata["behandelingen"].forEach((item)   => {
                if (item["naam"] === this.state.sex) {
                    treatments = item["behandelingen"];
                }
            }); 
        } else {
            treatments = this.props.getdata["behandelingen"];
        }
        return treatments;
    }

    renderTreatments = () => {
        if ((this.props.getdata["optie_vraag_geslacht"] && this.state.sex) || !this.props.getdata["optie_vraag_geslacht"])
            if (this.props.getdata.hasOwnProperty("behandelingen")) {
                let treatments = [];
                this.getTreatments().forEach((treatment) => {
                    let id = this.uniqueid();
                    let key = this.uniqueid();
                    let cls = this.isTreatmentSelected(treatment["id"]) ? "card treatment has-background-danger has-text-white" : "card treatment";
                    treatments.push(
                        <div className={cls} key={key} id={id} onClick={this.onClickTreatment(treatment)}>
                            <div className="card-body">
                                <div className="treatment-main">
                                    {this.decode(treatment["naam"])}
                                </div>
                                <div className="treatment-sub">
                                    {this.getNameSelectedSubTreatment(treatment["id"])}
                                </div>
                            </div>
                        </div>
                    );
                });
                return treatments;
            }
    }

    renderSubTreatments = () => {
        if (this.state.currentTreatment && this.state.currentTreatment["behandeling"]) {
            let subTreatments = [];
            this.state.currentTreatment["behandeling"].forEach((subTreatment) => {
                let key = this.uniqueid();
                let isChecked = this.isSubTreatmentChecked(subTreatment);
                subTreatments.push(
                    <div className="field" key={key}>
                        <input
                            onClick={(e) => this.onClickSubTreatment(e, subTreatment)} 
                            className="is-checkradio is-danger" 
                            id={"id_" + this.state.currentTreatment["id"] + "_" + subTreatment["id"]} 
                            type="checkbox" 
                            name={"name_" + this.state.currentTreatment["naam"]}
                            defaultChecked={isChecked}
                        />
                        <label htmlFor={"id_" + this.state.currentTreatment["id"] + "_" + subTreatment["id"]}>{this.decode(subTreatment["naam"])}</label>
                    </div>
                );
            });
            return subTreatments;
        }
    }

    renderStylists = () => {
        if (this.props.getdata["stylisten"] && this.props.images && (this.state.modal === "stylists")) {
            let stylists = [];
            this.props.getdata["stylisten"].forEach((stylist, index) => {
                let id = this.uniqueid();
                let key = this.uniqueid();
                let cls = this.isStylistSelected(stylist["id"]) ? "card stylist has-background-danger has-text-white" : "card stylist";
                if (stylist["naam"] === "Geen voorkeur") {
                    stylists.push(
                        <div className={cls} id={id} key={key} onClick={(e) => this.onClickStylist(stylist)}>
                            <div className="card-content"
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "160px",
                                }}>
                                <span>{stylist["naam"]}</span>
                            </div>
                        </div>
                    );
                } else {
                    stylists.push(
                        <div className={cls} id={id} key={index} onClick={(e) => this.onClickStylist(stylist)}>
                            <div className="card-image stylist-image">
                                <figure className="image is-128x128">
                                <img src={"data:image/png;base64, " + this.props.images["id_" + stylist["id"]]} alt=""/>
                                </figure>
                            </div>
                            <div className="card-content stylist-name">
                                <span>{stylist["naam"]}</span>
                            </div>
                        </div>
                    );
                }
            });
            return stylists;
        }
    }

    renderContent = () => {
        let content;
        if (this.props.getdata) {
            content = 
                <React.Fragment>
                    <div className="stepOne-header">
                        {this.renderHeader()}
                    </div>
                    <div className="stepOne-body">
                        {this.renderTreatments()}
                    </div>
                </React.Fragment>;
        } else {
            content = <div className="loader-container"><div className="loader"></div></div>;
        }
        return content;
    }

    onClickTreatment = (treatment) => {
        return () => {
            this.setState((prevState) => {
                prevState.currentTreatment = treatment;
                return prevState;
            }, this.openModal("subtreatments")); 
        }
    }

    getTreatmentName = () => {
        if (this.state.currentTreatment && this.state.currentTreatment["naam"]) {
            return this.state.currentTreatment["naam"];
        }
    }

    onClickStylist = (stylist) => {
        this.setState((prevState) => {
            prevState.stylist = stylist;
            return prevState;
        }, () => this.props.setStylist(stylist));
    }

    openModal = (name) => {
        return () => {
            $("." + name).addClass("is-active");
            let psModal = null;
            if (this.state.psModal) {
                this.state.psModal.update();
            } else {
                 psModal = new PerfectScrollbar("." + name + "-content", {
                    wheelSpeed: 2,
                    wheelPropagation: true,
                    minScrollbarLength: 20
                });
            }
            this.setState((prevState) => {
                prevState.modal = name;
                if (psModal) {
                    prevState.psModal = psModal;
                }
                return prevState;
            });
        }
    }

    closeModal = (name) => {
        return () => {
            $("." + name).removeClass("is-active");
            this.setState((prevState) => {
                prevState.modal = null;
                return prevState;
            });
        }
    }

    maxModal = () => {
        let cHeight = $(".container").height();
        return  (cHeight - 154) + "px";
    }
    
    decode = (str) => { 
        let el = document.createElement('div');
        if(str && typeof str === 'string') {
            str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
            str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
            el.innerHTML = str;
            str = el.textContent;
            el.textContent = '';
        return str;
        }
    }

    render = () => {
        return (
            <React.Fragment>
                <div className="columns" style={{width: "100%"}}>
                    <div className="column stepOne">
                        {this.renderContent()}
                    </div>
                </div>
                <div className="modal subtreatments">
                    <div className="modal-background"></div>
                    <div className="modal-content">
                        <div className="cModal" style={{maxHeight: this.maxHeightModalContent}}>
                            <div className="cModal-header">
                                {this.getTreatmentName()}
                            </div>
                            <div className="cModal-content subtreatments-content" style={{maxHeight: this.maxModal()}}>
                            {this.renderSubTreatments()}
                            </div>
                            <div className="cModal-footer">
                                <button className="button is-danger is-pulled-right" onClick={this.closeModal("subtreatments")}>Sluiten</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal stylists">
                    <div className="modal-background"></div>
                    <div className="modal-content">
                        <div className="cModal" style={{maxHeight: this.maxHeightModalContent}}>
                            <div className="cModal-header">
                                Stylisten
                            </div>
                            <div className="cModal-content stylists-content" style={{maxHeight: this.maxModal()}}>
                            {this.renderStylists()}
                            </div>
                            <div className="cModal-footer">
                                <button className="button is-danger is-pulled-right" onClick={this.closeModal("stylists")}>Sluiten</button>
                            </div>
                        </div>
                    </div>
                </div> 
            </React.Fragment>
        );
    }
}

export default StepOne;